module.exports = __webpack_public_path__ + "static/media/33-3.3715ae73.mp3";